export default "__VITE_ASSET__DoomtipG__"